import api from "./api";

// Capacidades + status de conexão (SFTP incluso) de uma transportadora —
// PO1-2620, H4/H5. Usado no drawer de Detalhe (H3) e no enriquecimento de
// linhas/cards quando precisa reconsultar uma transportadora isolada.

export async function getCapacidadesTransportadora(transportadoraId, embarcadorId) {
  const { data } = await api.get(`/transportadoras/${transportadoraId}/capacidades`, {
    params: embarcadorId ? { embarcadorId } : {},
  });
  return data;
}
